/**
 * Хекс-значения тем для MUI (MUI считает alpha/оттенки и не умеет это с CSS-переменными).
 * Должны совпадать со значениями в src/styles/_tokens.scss.
 */
export const lightPalette = {
  primary: '#3152C7',
  primaryHover: '#3D3ACE',
  danger: '#F93232',
  success: '#31AA27',
  bgApp: '#F8F8FA',
  bgSurface: '#FFFFFF',
  bgElevated: '#FFFFFF',
  textPrimary: '#212121',
  textSecondary: '#8A8894',
  border: '#E0E0F1',
};

export const darkPalette = {
  primary: '#7D9BFF',
  primaryHover: '#93ABFF',
  danger: '#FF6B6B',
  success: '#4ADE80',
  bgApp: '#0F1116',
  bgSurface: '#1A1D24',
  bgElevated: '#22262F',
  textPrimary: '#E6E7EA',
  textSecondary: '#9A99A5',
  border: '#2C3040',
};

export type AppPalette = typeof lightPalette;
